import React, { FC } from "react";
import { createPortal } from "react-dom";
import { Draggable } from "react-beautiful-dnd";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/CreateOutlined";
import DragIcon from "@mui/icons-material/DragIndicatorOutlined";
import { classNames } from "../../../../../utils/common/styling";
import { ISectionCTA } from "../ISectionCTA";
import { styles } from "./MovableSectionCTA.styles";
import { useCreatorThemeContext } from "../../../../../features/Common/modules/Theme/CreatorThemeContext";
import { SectionCTAContent } from "../SectionCTAContent/SectionCTAContent";

export const MovableSectionCTA: FC<ISectionCTA.IProps> = ({
  type,
  label,
  active,
  icon,
  onClick,
  id,
  index,
  className,
  labelClassName,
  labelStyle,
  showActions,
  showOnlyDrag,
  onEdit,
}) => {
  const theme = useCreatorThemeContext();
  const dragPortal = document.body;

  return (
    <Draggable
      draggableId={`draggable-${id}`}
      type={type ? `draggable-${type}-${id}` : `draggable-${id}`}
      index={index}
    >
      {(provided, snapshot) => {
        const ctaDragElement = (
          <span
            key={id}
            style={{ ...provided.draggableProps.style }}
            className="d-block"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div
              className={classNames(
                styles.root,
                active ? styles.active : styles.inactive,
                snapshot.isDragging && styles.draggable,
                className,
              )}
              onClick={onClick}
            >
              <div className={styles.container}>
                {/* LEFT SIDE */}
                <div className={styles.left}>
                  <SectionCTAContent
                    label={label}
                    icon={icon}
                    active={active || false}
                    labelClassName={labelClassName}
                    labelStyle={labelStyle}
                    theme={theme}
                  />
                </div>

                {/* RIGHT SIDE */}
                <div className={styles.right}>
                  {showActions && (
                    <div className={styles.actions}>
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          onEdit?.(e);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <div
                        {...provided.dragHandleProps}
                        className={styles.dragHandle}
                      >
                        <DragIcon className={styles.dragCta} />
                      </div>
                    </div>
                  )}
                  {showOnlyDrag && (
                    <div className={styles.actions}>
                      <div
                        {...provided.dragHandleProps}
                        className={styles.dragHandle}
                      >
                        <DragIcon className={styles.dragCta} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </span>
        );

        return snapshot.isDragging
          ? createPortal(ctaDragElement, dragPortal)
          : ctaDragElement;
      }}
    </Draggable>
  );
};
